/**
 * Org mapping configuration
 * Maps brand + country combinations to Byte Connect organization codes
 */
// Mapping of brand + country to Byte Connect org
export const ORG_MAPPINGS = [
    // Taco Bell UK (includes Great Britain and Ireland)
    { brand: 'TBC', country: 'GBR', org: 'tb_uk', displayName: 'Taco Bell UK' },
    { brand: 'TB', country: 'GBR', org: 'tb_uk', displayName: 'Taco Bell UK' },
    { brand: 'TBC', country: 'IRL', org: 'tb_uk', displayName: 'Taco Bell UK' },
    { brand: 'TB', country: 'IRL', org: 'tb_uk', displayName: 'Taco Bell UK' },
    // Taco Bell Spain
    { brand: 'TBC', country: 'ESP', org: 'tb_es', displayName: 'Taco Bell Spain' },
    { brand: 'TB', country: 'ESP', org: 'tb_es', displayName: 'Taco Bell Spain' },
    // Taco Bell Netherlands
    { brand: 'TBC', country: 'NLD', org: 'tb_nl', displayName: 'Taco Bell Netherlands' },
    { brand: 'TB', country: 'NLD', org: 'tb_nl', displayName: 'Taco Bell Netherlands' },
    // Taco Bell France
    { brand: 'TBC', country: 'FRA', org: 'tb_fr', displayName: 'Taco Bell France' },
    { brand: 'TB', country: 'FRA', org: 'tb_fr', displayName: 'Taco Bell France' },
    // KFC UK
    { brand: 'KFC', country: 'GBR', org: 'kfc_uk', displayName: 'KFC UK' },
    // Pizza Hut UK
    { brand: 'PH', country: 'GBR', org: 'ph_uk', displayName: 'Pizza Hut UK' },
    { brand: 'PHD', country: 'GBR', org: 'ph_uk', displayName: 'Pizza Hut UK' },
    // Default fallback
    { brand: 'DEFAULT', country: 'DEFAULT', org: 'tb_uk', displayName: 'Default Org' }
];
/**
 * Get org code based on brand and country
 */
export function getOrgFromBrandCountry(brand, country) {
    const mapping = ORG_MAPPINGS.find(m => m.brand === brand && m.country === country);
    if (mapping) {
        return { org: mapping.org, displayName: mapping.displayName };
    }
    // Fallback to default
    console.warn(`No org mapping found for brand: ${brand}, country: ${country}. Using default.`);
    const defaultMapping = ORG_MAPPINGS.find(m => m.brand === 'DEFAULT');
    return {
        org: defaultMapping?.org || 'tb_uk',
        displayName: defaultMapping?.displayName || 'Default Org'
    };
}
/**
 * Supported brands. Only these brands are currently supported by the app.
 * All other brands will receive a "brand not supported" response.
 */
export const SUPPORTED_BRANDS = ['TBC', 'TB'];
/**
 * Check if a brand is supported by the app.
 */
export function isSupportedBrand(brand) {
    if (!brand)
        return false;
    return SUPPORTED_BRANDS.includes(brand);
}
/**
 * Brand + country combinations we actively support right now.
 * Only tb_uk (Taco Bell UK) is live — other orgs require separate Cognito credentials.
 */
export const SUPPORTED_BRAND_COUNTRIES = [
    { brand: 'TBC', country: 'GBR' },
    { brand: 'TB', country: 'GBR' },
    // UK in the SDK includes Ireland (Great Britain and Ireland)
    { brand: 'TBC', country: 'IRL' },
    { brand: 'TB', country: 'IRL' },
];
/**
 * Check if a brand + country combination is actively supported.
 * Only stores matching SUPPORTED_BRAND_COUNTRIES will be shown in the app.
 */
export function isSupportedBrandCountry(brand, country) {
    if (!brand || !country)
        return false;
    return SUPPORTED_BRAND_COUNTRIES.some(m => m.brand === brand && m.country === country);
}
/**
 * Construct Byte Graph URL with org
 */
export function getByteGraphUrl(org, environment) {
    const baseUrls = {
        local: 'https://api.staging.yumconnect.dev',
        dev: 'https://api.staging.yumconnect.dev',
        staging: 'https://api.staging.yumconnect.dev',
        production: 'https://api.prod.hopper.yumconnect.dev'
    };
    const baseUrl = baseUrls[environment] || baseUrls.staging;
    return `${baseUrl}/${org}/business/graphql`;
}
